<template>
	<div class="parameter-items">
		<report-parameter-item v-for="(parameter, index) in localReportParameters" :key="parameter.key" v-model="localReportParameters[index]" @remove="remove" />
		<div class="add" @click="add()"><i class="fal fa-circle-plus add-icon"></i><span>افزودن پارامتر جدید</span></div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'

	export default {
		name: 'ReportParameters',
		data() {
			return {
				localReportParameters: [],
				variableVisible: false,
				selectedVariableItem: null,
			}
		},
		watch: {
			reportParameters: {
				deep: true,
				immediate: true,
				handler() {
					let news = this.localReportParameters.filter(x => x.isNew && this.reportParameters.findIndex(f => x.key === f.key) === -1)
					this.localReportParameters = [...this.reportParameters]
					this.localReportParameters.push(...news)
				},
			},
		},
		mounted() { },
		computed: {
			...mapGetters({ reportParameters: 'queryDesigner/reportParameters' }),
		},
		methods: {
			add() {
				this.localReportParameters.push({
					key: Date.now().toString(),
					name: '',
					type: 'string',
					isRequired: false,
					isNew: true,
					smartDate: {},
					enum: null
				})
			},
			remove(item) {
				let index = this.localReportParameters.findIndex((x) => x.key === item.key)
				if (index > -1) this.localReportParameters.splice(index, 1)
			},
		},
	}
</script>

<style></style>